<template>
  <div class="noDataBox">
    <img src="./nofind.png">
    <p style="line-height: 30px;font-size: 16px;color: #909399;">
      暂无数据，请稍后再试
    </p>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {};
  },
  components: {},
  computed: {},
  methods: {},
  mounted () {

  }
};
</script>
<style lang="scss" scoped>
  .noDataBox{
    width: 100%;
    text-align: center;
  }
</style>
